import { ARCHIVE_EXTENSION, DEFAULT_ARCHIVE_BASE_NAME } from '../../constants';
export const generateArchiveName = (baseName) => {
    const trimmedBaseName = baseName?.trim();
    return `${trimmedBaseName || DEFAULT_ARCHIVE_BASE_NAME}${ARCHIVE_EXTENSION}`;
};
